
<p-tabMenu #tab [model]="dataSourceValues" [activeItem]="activeLabel" [scrollable]="true"></p-tabMenu>
<div>
  <div class="m-2 sizedet">
        <div *ngFor="let item of dataSourceValues">
          <div id = '{{item.order}}' class="row col-12" style="background: #eee;color: #333;">
           <span style='font-size: 1.15rem;border-radius: 5px;margin-right: 10px;cursor:pointer'>{{item.label}} {{'text.details' | translate}}</span>
           </div>
          <div *ngIf="item.value === 'Single'">
            <div class="container">
            <div class="row">
              <div class="col-3 my-2" *ngFor="let atrb of item.attributes">
                <div class="row col-12">
                  <b>{{ atrb.key}}</b>
                  <label class="form-value" *ngIf='!editFlag'>{{ atrb.value}} </label>
                  <input type="text" class="form-control" *ngIf='editFlag' />
              </div>
              </div>
            </div>
            </div>
          </div>
          <div *ngIf="item.value === 'Multiple'">
            <div class="m-3">
              <p-table
              [columns]="headersMultiple[item.order]"
              responsiveLayout="scroll"
              [value]="item.attributes"
              dataKey="id"
              styleClass="p-datatable-sm"
              class="common-table bordered"
              [resizableColumns]="true"
              columnResizeMode="expand">
                
                <ng-template pTemplate="header" let-rowData let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th>
                        {{ col }}
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr> 
                        <td *ngFor="let col of columns">{{ rowData[col] }}</td>
                    </tr>
                </ng-template>
              </p-table>
            </div>
            <!-- <div *ngIf="item.order === '1'" class="m-3">
              <p-table
              [columns]="headers1"
              responsiveLayout="scroll"
              [value]="item.attributes"
              dataKey="id"
              styleClass="p-datatable-sm"
              class="common-table bordered"
              [resizableColumns]="true"
              columnResizeMode="expand">
                
                <ng-template pTemplate="header" let-rowData let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th>
                        {{ col }}
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr> 
                        <td *ngFor="let col of columns">{{ rowData[col] }}</td>
                    </tr>
                </ng-template>
              </p-table>
            </div>-->
          </div>
          <div *ngIf="item.value === 'Combination'">
            <div class="container">
            <div class="row">
              <div class="col-3 my-2" *ngFor="let atrb of item.HeaderAttributes">
                <div class="row col-12">
                  <b>{{ atrb.key}}</b>
                  <label class="form-value" *ngIf='!editFlag' [style.white-space]="'pre-line'">{{ atrb.value}} </label>
                  <input type="text" class="form-control" *ngIf='editFlag' />
              </div>
              </div>
            </div>
            <div class="m-3">
              <p-table
              [columns]="headersCombination[item.order]"
              responsiveLayout="scroll"
              [value]="item.attributes"
              dataKey="id"
              styleClass="p-datatable-sm"
              class="common-table bordered"
              [resizableColumns]="true"
              columnResizeMode="expand">
                
                <ng-template pTemplate="header" let-rowData let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th>
                        {{ col }}
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr> 
                        <td *ngFor="let col of columns">{{ rowData[col] }}</td>
                    </tr>
                </ng-template>
              </p-table>
            </div>
            <!-- <div *ngIf="item.order === '1'" class="m-3">
              <p-table
              [columns]="headers1"
              responsiveLayout="scroll"
              [value]="item.attributes"
              dataKey="id"
              styleClass="p-datatable-sm"
              class="common-table bordered"
              [resizableColumns]="true"
              columnResizeMode="expand">
                
                <ng-template pTemplate="header" let-rowData let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th>
                        {{ col }}
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr> 
                        <td *ngFor="let col of columns">{{ rowData[col] }}</td>
                    </tr>
                </ng-template>
              </p-table>
            </div>
            <div *ngIf="item.order === '7'" class="m-3">
              <p-table
              [columns]="headers7"
              responsiveLayout="scroll"
              [value]="item.attributes"
              dataKey="id"
              styleClass="p-datatable-sm"
              class="common-table bordered"
              [resizableColumns]="true"
              columnResizeMode="expand">
                
                <ng-template pTemplate="header" let-rowData let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th>
                        {{ col }}
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr> 
                        <td *ngFor="let col of columns">{{ rowData[col] }}</td>
                    </tr>
                </ng-template>
              </p-table>
            </div> -->
            </div>
          </div>
      </div>
  </div>
</div>